export default __webpack_public_path__ + "static/media/voucherButtonIcon.ae9624c8.svg";